import React from "react";
import classes from "./СoveredBackground.module.css";

type Props = {
  children: React.ReactNode;
  color?: string;
};

const СoveredBackground = ({ children, color }: Props) => {
  const style: React.CSSProperties = color ? { backgroundColor: color } : {};
  return (
    <div className={classes.coveredBackground} style={style}>
      <div className={classes.coveredBackground__item}>{children}</div>
    </div>
  );
};

export default СoveredBackground;
